import { FC } from 'react'
import * as React from 'react'

import { FontFamilies, color } from '../../../../../style/variables'
import { CustomLink } from '../../../../links'
import RightArrow from '../RightArrow'

export interface Tier1MenuItemProps {
  label: string
  href: string
  onSelect: () => void
  onNavigate: () => void
  isLink: boolean
  selected: boolean
}

const Tier1MenuItem: FC<Tier1MenuItemProps> = ({ label, onSelect, onNavigate, isLink, href, selected }) => {
  return (
    <>
      <style jsx>{`
        .nav-item {
          text-decoration: none;
          width: 280px;
          height: 64px;
          font-family: ${FontFamilies.barlow};
          font-size: 32px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 2;
          letter-spacing: -0.32px;
          color: ${selected ? color.brandPrimary : color.textStandard};
          cursor: pointer;
          position: relative;
        }
        .nav-item:hover {
          color: ${color.brandPrimary};
        }
        .nav-item:target {
          color: ${color.white};
        }
        .right-arrow {
          position: absolute;
          right: 0px;
          display: none;
          top: 0px;
          justify-content: center;
          align-items: center;
          height: 64px;
        }
        .nav-item:hover .right-arrow {
          display: flex;
        }
      `}</style>
      {!isLink && (
        <div className="nav-item" onClick={onSelect} onMouseOver={onSelect} role="link">
          {label}
          <div className="right-arrow">
            <RightArrow />
          </div>
        </div>
      )}
      {isLink && href.startsWith('/virgin-red') && (
        <CustomLink to={href}>
          <div className="nav-item" onClick={onNavigate} onMouseOver={onSelect} role="link">
            {label}
            <div className="right-arrow">
              <RightArrow />
            </div>
          </div>
        </CustomLink>
      )}
      {isLink && !href.startsWith('/virgin-red') && (
        <a href={href} className="nav-item" onClick={onNavigate} onMouseOver={onSelect}>
          {label}
          <div className="right-arrow">
            <RightArrow />
          </div>
        </a>
      )}
    </>
  )
}

export default Tier1MenuItem
